import React, {} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles({

    root: {
      paddingRight:20,
      paddingTop:5,
      color: '#666',
    },
    highlight: {
        color: '#0C4C35'
    }
  });

export default function SupportPapper(props) {
  const classes = useStyles();
  const support_email = process.env.REACT_APP_SITE_SUPPORTEMAIL;
  const support_number = process.env.REACT_APP_SITE_SUPPORTNUMBER;

  return (
    <div className={classes.root}>
      <Box fontWeight="fontWeightBold" fontSize={14}>Support Team: <span className={classes.highlight}>{support_number}</span></Box>
      <Box fontWeight="fontWeightBold" fontSize={14}>Email: <span className={classes.highlight}>{support_email}</span></Box>
    </div>
  );
}
